import { render, staticRenderFns } from "./PatternCatalogue.vue?vue&type=template&id=43697266&scoped=true&"
import script from "./PatternCatalogue.vue?vue&type=script&lang=js&"
export * from "./PatternCatalogue.vue?vue&type=script&lang=js&"
import style0 from "./PatternCatalogue.vue?vue&type=style&index=0&id=43697266&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43697266",
  null
  
)

export default component.exports